import services from "../services";
import * as types from "./mutation-type";

export const setImagesModalCarousel = ({commit}, payload) => {
    commit(types.SET_IMAGES, payload)
}
